import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { BASE_URL } from "../../../config/axios";
import { ToastContainer } from "react-toastify";
import { handleErrorToast } from "../../CustomFunctions";
import { Eye } from '../../AllSvg';
import { Package, Search, X } from "lucide-react";

const AdminInventoryitemlist = ({ i }) => {
  const [show, setShow] = useState(false);
  const [buffer, setBuffering] = useState(true); //buffering logic

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    getSubCompanyEmployees();
  };

  const [subcompanyEmployees, setSubCompanyEmployees] = useState([]);

  const getSubCompanyEmployees = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/filterbyproj/null/${i.id}/`
      );
      setSubCompanyEmployees(res.data)

      const getAlphaNumericParts = (code) => {
        const match = code.match(/^([A-Za-z]+)(\d+)$/); // Match alphabetic and numeric parts
        if (match) {
          return { alphaPart: match[1], numericPart: parseInt(match[2], 10) };
        } else {
          return { alphaPart: "", numericPart: 0 };
        }
      };

      const sortedList = res.data.sort((a, b) => {
        const { alphaPart: alphaA, numericPart: numericA } =
          getAlphaNumericParts(a.emp_code);
        const { alphaPart: alphaB, numericPart: numericB } =
          getAlphaNumericParts(b.emp_code);

        if (alphaA !== alphaB) {
          return alphaA.localeCompare(alphaB); // Sort alphabetically
        } else {
          return numericA - numericB; // Then sort numerically
        }
      });
      setSubCompanyEmployees(sortedList);
    } catch (err) {
      //toast Logic
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    getSubCompanyEmployees();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filteredEmployees = subcompanyEmployees
    ?.filter((e) =>
      e.project_short_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      e.emp_code.toString().includes(searchQuery.toLowerCase())
    )
    .sort((a, b) => a.emp_code - b.emp_code);

  return (
    <>
      <button title="View" className="model-view-button-modern actionn-icon" style={{ background: "#00000075" }} onClick={handleShow}>
        <Eye size={16} color="#fff" />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="lg">
        <Modal.Header className="modern-modal-header">
          <div className="header-content">
            <div style={{ color: "white" }}>
              <Package size={24} />
            </div>
            <div>
              <Modal.Title>List Item: {i.item_name}</Modal.Title>
              <p className="header-subtitle" style={{ color: "white" }}>
                Employees currently issued this item
              </p>
            </div>
          </div>
          <button className="close-btn" onClick={handleClose}>
            <X size={20} />
          </button>
        </Modal.Header>

        <Modal.Body className="modern-modal-body">
          <div className="table-css-white-background">
            <div className="table-heading-flex">
              <div className="flex-row">
                <div className="table-searchh">
                  <div>
                    <Search size={14} color="#2B3674" />
                  </div>
                  <div>
                    <input
                      placeholder="Search"
                      className="navbar-inputt font-weight400  font-size-text"
                      value={searchQuery}
                      onChange={handleSearchChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            {buffer ? (
              <div className="loader" style={{ width: "100%" }}>
                <div className="child"></div>
              </div>
            ) : (
              <table className="table-css">
                <thead>
                  <tr className="custom-table-head-tr">
                    <th className="align-left">Sr.no</th>
                    <th className="align-right">Emp Code</th>
                    <th className="align-right">Project Name</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredEmployees?.length > 0 ? (
                    filteredEmployees.map((emp, index) => (
                      <tr className="custom-table-head-td" key={index}>
                        <td className="align-left">{index + 1}</td>
                        <td className="align-right">{emp.employee_emp_code}</td>
                        <td className="align-right">{emp.project_short_name}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="align-center">No records found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>

          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};



export default AdminInventoryitemlist;